import React, { useMemo } from 'react';
import { useImmerReducer } from 'use-immer';

import { CREATE_USER, EDIT_USER, ADD_TEAM } from 'constants/drawerTitles';

import CreateUser from '../CreateUser';
import EditUser from '../EditUser';
import AddTeam from '../AddTeam';

import { UserDrawerContext, InitialState } from './UserDrawerContext';
import { reducer } from './reducer';

const UserDrawerContent = ({ drawerTitle, toggleDrawer }) => {
  const [userDrawerState, dispatchUserDrawer] = useImmerReducer(
    reducer,
    InitialState,
  );

  const contextValue = useMemo(
    () => ({
      userDrawerState,
      dispatchUserDrawer,
    }),
    [userDrawerState, dispatchUserDrawer],
  );

  return (
    <UserDrawerContext.Provider value={contextValue}>
      {drawerTitle === CREATE_USER && (
        <CreateUser toggleDrawer={() => toggleDrawer(drawerTitle)} />
      )}
      {drawerTitle === EDIT_USER && (
        <EditUser toggleDrawer={() => toggleDrawer(drawerTitle)} />
      )}
      {drawerTitle === ADD_TEAM && (
        <AddTeam toggleDrawer={() => toggleDrawer(drawerTitle)} />
      )}
    </UserDrawerContext.Provider>
  );
};

export default UserDrawerContent;
